import {
  type PropsWithChildren,
  type ReactElement,
  useEffect,
  useState,
} from 'react';

import { getStratoLogger } from '../../../core/sdk/sdk-logger.js';
import { SeriesActionsTemplate } from '../types/series-actions-template.js';

export const useCustomSeriesActions = (
  actions: SeriesActionsTemplate | undefined,
  isOpen: boolean,
) => {
  const [customActions, setCustomActions] =
    useState<ReactElement<PropsWithChildren> | null>(null);
  const logger = getStratoLogger('useCustomSeriesActions');

  useEffect(() => {
    if (actions && isOpen) {
      if (actions instanceof Promise) {
        actions
          .then((resolvedActions) => {
            setCustomActions(resolvedActions);
          })
          .catch((error) => {
            logger.error('Failed to load series actions', error);
          });
      } else {
        setCustomActions(actions);
      }
    } else {
      setCustomActions(null);
    }
  }, [actions, isOpen]);

  return customActions;
};
